import React from "react";
import { ActionIcon, rem } from '@mantine/core';
import { IconDots, IconEye, IconDownload } from "@tabler/icons-react";
import { MantineMenu, MantineMenuDropdown, MantineMenuItem, MantineMenuTarget } from "../../components/mantine/menu";
import toast from "toastr";
import { saveAs } from 'file-saver'
const ActionMenuBySiteId = (props:any) => {
    const { setSelectedCategory, item } = props;
    const handleViews = () => {
        if (item) {
            const fileUrl = item.imageUrl || item.uploadFile;
            if (fileUrl) {
                window.open(fileUrl, "_blank");
            } 
            setSelectedCategory(item);
        } else {
            toast.error("Item is undefined or null");
        }
    };
    
    const handleDownload = async () => {
        if (item) {
            try {
                const fileUrl = item.imageUrl || item.uploadFile;
                const response = await fetch(fileUrl);
                if (!response.ok) throw new Error('Network response was not ok');

                //const blob = await response.blob();
                const contentType = response.headers.get('Content-Type');
                if (!contentType) {
                    throw new Error("Content-Type header is missing");
                }
    
                let extension = contentType.includes('image/jpeg') ? '.jpg' : contentType.includes('application/pdf') ? '.pdf' : '';

                const filename = item.categoryName ? `${item.categoryName}${extension}` : `download${extension}`;
                // const blobUrl = window.URL.createObjectURL(blob);
                // const link = document.createElement('a');
                // link.href = blobUrl;
                // link.setAttribute('download', filename);

                // document.body.appendChild(link);
                // link.click();
                // link.parentNode?.removeChild(link);
                // window.URL.revokeObjectURL(blobUrl);
                saveAs(item.imageUrl || item.uploadFile, filename);
            } catch (error) {
                //console.error('Error downloading the file:', error);
                //toast.errorlert('Failed to download file. Please try again later.');
                window.open(item.imageUrl || item.uploadFile, "_blank");
            }
        } else {
            toast.error('URL or File not found for this Category');
        }
    };

    return (
        <MantineMenu transitionProps={{ transition: 'pop' }} withArrow position="bottom-end" withinPortal>
            <MantineMenuTarget>
                <div style={{ textAlign: 'right' }}>
                    <ActionIcon variant="subtle" color="white">
                        <IconDots style={{ width: rem(16), height: rem(16) }} />
                    </ActionIcon>
                </div>
            </MantineMenuTarget>
            <MantineMenuDropdown>
                <MantineMenuItem
                    leftSection={<IconEye style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                    onClick={handleViews}
                >
                    View
                </MantineMenuItem>
                <MantineMenuItem
                    leftSection={<IconDownload style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                    onClick={handleDownload}
                >
                    Download
                </MantineMenuItem>
            </MantineMenuDropdown>
        </MantineMenu>
    );
};

export default ActionMenuBySiteId;